import React from 'react';
import { useTranslation } from 'react-i18next';

import ErrorLayout from '../../../layouts/ErrorLayout';

const ForbiddenPage: React.FC = () => {
  const { t } = useTranslation();

  const title = t('Error: Forbidden: Title');
  const description = t('Error: Forbidden: Description');

  return <ErrorLayout description={description} title={title} />;
};

export default ForbiddenPage;
